import { createAction } from 'redux-act'

import { RazorpayData } from '../../checkout/types'

export const initRazorpayCheckout = createAction<RazorpayData>('Razorpay / init checkout')
export const completeRazorpayCheckout = createAction<void>('Razorpay / complete checkout')

export const apiInitRazorpayStart = createAction<void>('Razorpay / API init start')
export const apiInitRazorpaySuccess = createAction<void>('Razorpay / API init success')
export const apiInitRazorpayFail = createAction<void>('Razorpay / API init fail')
